// ============================================================
// RADAR PROFISSIONAL DA NOVA ECONOMIA™
// Dados do teste vocacional — perguntas por dimensão
// ============================================================

// Lista de profissões centralizada em src/data/professions.js
export { PROFESSION_NAMES as PROFESSIONS } from "@/data/professions";

// Dimensões: cognitive | operational | behavioral | motivational | risk | baggage
// Cada resposta incrementa scores nas dimensões listadas

export const QUESTIONS = [
  // === DIMENSÃO 1: COGNITIVA ===
  {
    id: "cog_1",
    dimension: "cognitive",
    text: "Quando você recebe um problema novo, qual é sua reação natural?",
    options: [
      { label: "Pesquiso, organizo as informações e estruturo uma solução", value: "analytic" },
      { label: "Já começo a testar na prática o mais rápido possível", value: "executor" },
      { label: "Penso no impacto geral e no cenário estratégico", value: "strategic" },
      { label: "Crio algo novo, fora do óbvio", value: "creative" },
    ],
  },
  {
    id: "cog_2",
    dimension: "cognitive",
    text: "Você prefere:",
    options: [
      { label: "Criar algo do zero", value: "creative" },
      { label: "Otimizar algo que já existe", value: "analytic" },
      { label: "Definir a direção geral", value: "strategic" },
      { label: "Colocar a mão na massa e entregar", value: "executor" },
    ],
  },
  {
    id: "cog_3",
    dimension: "cognitive",
    text: "Qual dessas atividades te dá mais energia?",
    options: [
      { label: "Analisar dados e encontrar padrões", value: "analytic" },
      { label: "Escrever, criar e comunicar ideias", value: "creative" },
      { label: "Planejar campanhas e definir estratégias", value: "strategic" },
      { label: "Executar tarefas e bater metas", value: "executor" },
    ],
  },

  // === DIMENSÃO 2: OPERACIONAL ===
  {
    id: "op_1",
    dimension: "operational",
    text: "Como você prefere trabalhar no dia a dia?",
    options: [
      { label: "Rotina previsível com processos bem definidos", value: "routine" },
      { label: "Desafios diferentes toda semana", value: "adaptive" },
      { label: "Alta intensidade com metas agressivas", value: "commercial" },
      { label: "Autonomia para criar meu próprio ritmo", value: "autonomous" },
    ],
  },
  {
    id: "op_2",
    dimension: "operational",
    text: "Você se sente confortável seguindo scripts e processos padronizados?",
    options: [
      { label: "Sim, prefiro ter um guia claro", value: "routine" },
      { label: "Às vezes, desde que haja espaço para adaptar", value: "adaptive" },
      { label: "Não muito, prefiro improvisar", value: "autonomous" },
      { label: "Depende do objetivo final", value: "commercial" },
    ],
  },
  {
    id: "op_3",
    dimension: "operational",
    text: "Com qual cenário você se identifica mais?",
    options: [
      { label: "Checklists, processos e entregas organizadas", value: "routine" },
      { label: "Projetos com começo, meio e fim claros", value: "adaptive" },
      { label: "Competição, metas e resultados em tempo real", value: "commercial" },
      { label: "Criação livre sem muitos gatilhos externos", value: "autonomous" },
    ],
  },

  // === DIMENSÃO 3: COMPORTAMENTAL ===
  {
    id: "beh_1",
    dimension: "behavioral",
    text: "Qual papel você ocupa naturalmente num grupo?",
    options: [
      { label: "Lidero e tomo decisões", value: "leader" },
      { label: "Articulo e vendo ideias para o grupo", value: "communicator" },
      { label: "Organizo e garanto que tudo funcione", value: "operator" },
      { label: "Executo bem minha parte sem precisar aparecer", value: "backstage" },
    ],
  },
  {
    id: "beh_2",
    dimension: "behavioral",
    text: "Como você se sente em relação a vendas?",
    options: [
      { label: "Amo — me sinto energizado(a) ao vender", value: "sales_high" },
      { label: "Consigo vender quando necessário", value: "sales_medium" },
      { label: "Prefiro criar ou entregar do que vender", value: "sales_low" },
      { label: "Prefiro bastidor — análise, operação, suporte", value: "backstage" },
    ],
  },
  {
    id: "beh_3",
    dimension: "behavioral",
    text: "Você prefere linha de frente ou bastidor?",
    options: [
      { label: "Linha de frente — gosto de exposição e contato direto", value: "frontline" },
      { label: "Um pouco dos dois — vario conforme o contexto", value: "hybrid" },
      { label: "Bastidor — prefiro trabalhar por trás", value: "backstage" },
      { label: "Prefiro liderar nos bastidores, sem aparecer muito", value: "backstage" },
    ],
  },

  // === DIMENSÃO 4: MOTIVACIONAL ===
  {
    id: "mot_1",
    dimension: "motivational",
    text: "O que mais pesa na sua decisão de carreira?",
    options: [
      { label: "Segurança e estabilidade", value: "security" },
      { label: "Liberdade e autonomia", value: "autonomy" },
      { label: "Crescimento financeiro rápido", value: "ambition" },
      { label: "Impacto e propósito", value: "impact" },
    ],
  },
  {
    id: "mot_2",
    dimension: "motivational",
    text: "O que te mantém motivado(a) no longo prazo?",
    options: [
      { label: "Reconhecimento e crescimento na carreira", value: "ambition" },
      { label: "Criar coisas novas e ver o resultado", value: "autonomy" },
      { label: "Saber que estou ajudando alguém", value: "impact" },
      { label: "Saber que tenho previsibilidade financeira", value: "security" },
    ],
  },

  // === DIMENSÃO 5: RISCO ===
  {
    id: "risk_1",
    dimension: "risk",
    text: "Como você se sente com renda variável (comissão, projetos freelance)?",
    options: [
      { label: "Adoro — quanto mais risco, mais potencial", value: "high" },
      { label: "Aceito se houver base fixa", value: "medium" },
      { label: "Prefiro salário fixo e previsível", value: "low" },
      { label: "Nunca pensei nisso ainda", value: "medium" },
    ],
  },
  {
    id: "risk_2",
    dimension: "risk",
    text: "Como você reage a começar do zero numa área nova?",
    options: [
      { label: "Encaro como oportunidade — gosto de construir", value: "high" },
      { label: "Me sinto ansioso(a) mas consigo", value: "medium" },
      { label: "Prefiro ter base antes de mudar", value: "low" },
      { label: "Depende do apoio que terei", value: "medium" },
    ],
  },

  // === DIMENSÃO 6: BAGAGEM ===
  {
    id: "bag_1",
    dimension: "baggage",
    text: "Qual área mais representa sua experiência anterior?",
    options: [
      { label: "Exatas, tecnologia ou engenharia", value: "tech" },
      { label: "Humanas, educação ou comunicação", value: "humanities" },
      { label: "Vendas, atendimento ou comercial", value: "sales" },
      { label: "Design, artes ou criação visual", value: "design" },
    ],
  },
  {
    id: "bag_2",
    dimension: "baggage",
    text: "Qual habilidade você já domina hoje?",
    options: [
      { label: "Escrita, comunicação, storytelling", value: "writing" },
      { label: "Organização, processos, gestão", value: "management" },
      { label: "Lógica, dados, análise", value: "analysis" },
      { label: "Criatividade visual, edição, design", value: "visual" },
    ],
  },
];